import axiosInstance from "../../../axios/axiosInstance";

export const updateFCM = (props) => (onResponse) => {
  try {
    let BASE_URL = "message/?type=fcm_token_update";

    axiosInstance
      .post(BASE_URL, props)
      .then((response) => {
        onResponse(response?.data);
      })
      .catch((error) => {
        onResponse(error?.data);
      });
  } catch (error) {}
};
